import React, { useState } from "react";
import { format } from "date-fns";
import { it } from "date-fns/locale";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";

interface CalendarEvent {
  title: string;
  date: string;
  eventType: string;
  eventData: any;
}

interface ToDoHomeProps {
  events: CalendarEvent[];
  selectedDate: string | null;
}

const ToDoHome: React.FC<ToDoHomeProps> = ({ events, selectedDate }) => {
  const [expandedRows, setExpandedRows] = useState<any[]>([]);

  const handleRowToggle = (event: any) => {
    setExpandedRows(event.data); // PrimeReact gestisce automaticamente l'espansione
  };

  const renderEventDetails = (event: CalendarEvent) => {
    const { eventType, eventData } = event;
    const scadenza = format(new Date(eventData.scadenza), "dd MMMM yyyy", { locale: it });

    if (eventType === "red-dot") {
      return (
        <div style={{ textAlign: "left" }}>
          <div>
            <strong>Descrizione:</strong> {eventData.descrizione || "-"}
          </div>
          <div>
            <strong>Scadenza:</strong> {scadenza || "-"}
          </div>
        </div>
      );
    }

    return (
      <div style={{ textAlign: "left" }}>
        <div>
          <strong>Data Esecuzione:</strong>{" "}
          {format(new Date(eventData.dataEsecuzione), "dd MMMM yyyy", { locale: it }) || "-"}
        </div>
        <div>
          <strong>Scadenza:</strong> {scadenza || "-"}
        </div>
      </div>
    );
  };

  const formattedDate = selectedDate ? format(new Date(selectedDate), "EEEE, dd MMMM yyyy", { locale: it }) : "";

  return (
    <div className="todo-home-container">
      {!selectedDate ? (
        <h3 className="ps-3 pt-2">Eventi del giorno</h3>
      ) : (
        <h3 className="ps-3 pt-2">Eventi del giorno - {formattedDate}</h3>
      )}

      {events.length > 0 ? (
        <div className="ps-3 pt-2">
          <DataTable
            value={events}
            expandedRows={expandedRows}
            onRowToggle={handleRowToggle}
            rowExpansionTemplate={(data) => renderEventDetails(data)}
            dataKey="title" // Chiave unica per identificare le righe
            className="p-datatable-striped"
          >
            <Column expander style={{ width: "3em" }} />
            <Column
              className="text-start"
              body={(rowData) =>
                rowData.eventType === "red-dot" ? `Task: ${rowData.title}` : `Evento: ${rowData.title}`
              }
            />
          </DataTable>
        </div>
      ) : (
        <p className="ps-3 mt-2">Nessun evento per questo giorno.</p>
      )}
    </div>
  );
};

export default ToDoHome;
